const ANALYZE_PAGE_VIEW = 'ANALYZE_PAGE_VIEW';
const ANALYZE_PRODUCT_NOT_FOUND_PAGE_VIEW = 'ANALYZE_PRODUCT_NOT_FOUND_PAGE_VIEW';

export {
  ANALYZE_PAGE_VIEW,
  ANALYZE_PRODUCT_NOT_FOUND_PAGE_VIEW,
};
